import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDestinationsData } from "../../utils/destinations-util";

export const getDestinationsDataReq = createAsyncThunk(
  "destinationsPageData",
  async (res) => {
    const response = await getDestinationsData(res);
    return response.data;
  }
);

const destinationsSlice = createSlice({
  name: "destinations",
  initialState: {
    destinationsPageData: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDestinationsDataReq.fulfilled, (state, action) => {
      state.loading = false;
      state.destinationsPageData = action.payload;
      state.error = null;
    });
    builder.addCase(getDestinationsDataReq.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getDestinationsDataReq.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {} = destinationsSlice.actions;
export default destinationsSlice.reducer;
